import { APPROVAL } from "pages/Sales/Register/utils/vars"

export const APPROVAL_OPTIONS = Object.keys(APPROVAL).filter(item => typeof item === 'string' && item.length === 1).map((item) => ({ value: item as unknown as string, label: APPROVAL[item as unknown as number] }))